import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faProjectDiagram,
  faCalendarAlt,
  faGlobe,
  faUser,
  faUsers,
  faCommentDots,
  faStar,
  faMailBulk
} from '@fortawesome/free-solid-svg-icons';
const token = localStorage.getItem('token');

const ClientDetails = () => {
  const { id } = useParams();
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  useEffect(() => {
    const fetchClient = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await axios.get(`/client/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log(res)
        setClient(res.data);
      } catch (err) {
        setError('Erreur lors du chargement du client.');
      } finally {
        setLoading(false);
      }
    };

    fetchClient();
  }, [id]);

  if (loading) return <p>Chargement du client...</p>;
  if (error) return <p className="text-red-600">{error}</p>;
  if (!client) return <p>Client non trouvé.</p>;

  return (
    <div className="client-detail-container">
      {/* Header Section */}
      <div className="client-header">
        <div className="header-content">
          <div className="breadcrumb">
            <Link to="/admin/clients" className="back-button">
              <FontAwesomeIcon icon={faArrowLeft} />
              <span>Retour à la liste</span>
            </Link>
          </div>
          <h1 className="client-title">
            <FontAwesomeIcon icon={faUser} className="title-icon" />
            {client.name}
          </h1>
        </div>
      </div>

      <div className="project-content">
        {/* Client Image */}
        {client.photoUrl && (
          <div className="client-image-section">
            <div className="image-container">
              <img
                src={`/${client.photoUrl}`}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = '/defaults/defaultMemberImage.jpg';
                }}
                alt="Image du client"
                className="project-image"
              />
            </div>
          </div>
        )}

        {/* Main Information */}
        <div className="client-info-grid">
          <div className="info-card main-info">
            
            <div className="client-details">
              <div className="detail-item">
                <FontAwesomeIcon icon={faMailBulk} className="detail-icon" />
                <div className="detail-content">
                  <span className="detail-label">E-mail</span>
                  <span className="detail-value">{client.email}</span>
                </div>
              </div>

              {client.jobTitle && (
                <div className="detail-item">
                  <FontAwesomeIcon icon={faGlobe} className="detail-icon" />
                  <div className="detail-content">
                    <span className="detail-label">Poste</span>
                    <a href={client.jobTitle} target="_blank" rel="noopener noreferrer" className="website-link">
                      {client.jobTitle}
                    </a>
                  </div>
                </div>
              )}

              {client.client && (
                <div className="detail-item">
                  <FontAwesomeIcon icon={faUser} className="detail-icon" />
                  <div className="detail-content">
                    <span className="detail-label">Client</span>
                    <span className="detail-value">{client.client.name} ({client.client.email})</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/*Projets */}
          <div className="info-card collaborators-card">
            <h3 className="card-title">
              <FontAwesomeIcon icon={faProjectDiagram} />
              Projets
            </h3>
            {client.projects.length > 0 ? (
              <div className="collaborators-list">
                {client.projects.map((col) => (
                  <Link to={`/admin/projects/${col.id}`} className="back-button">
                    <div className="collaborator-avatar">
                      <FontAwesomeIcon icon={faProjectDiagram} />
                    </div>
                    <div className="collaborator-info">
                      <span className="collaborator-name">{col.projectName}</span>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <p className="no-data">Aucun projet assigné</p>
            )}
          </div>
        </div>

      </div>

      
    </div>
  );
};

export default ClientDetails;
